// Source: https://www.telerik.com/blogs/how-to-use-context-api-with-hooks-efficiently-while-avoiding-performance-bottlenecks
import { useContext } from 'react';

export const useContextFactory = (name, context) => () => {
  const ctx = useContext(context);
  if (ctx === undefined) {
    throw new Error(
      `use${name}Context must be used within a ${name}ContextProvider.`,
    );
  }
  return ctx;
};
